module.exports = __webpack_public_path__ + "static/media/icon-offres.dfccaf1f.svg";